export const resizeCloudinaryUrl = (url, y, x) => {
  if (!url || typeof url !== "string") return url;

  const isCloudinary =
    url.includes("res.cloudinary.com") && url.includes("/upload/");

  if (!isCloudinary) return url;

  const hasSize =
    new RegExp(`[,/]w_${x}[,/]`).test(url) &&
    new RegExp(`[,/]h_${y}[,/]`).test(url);
  const hasAutoFormat = url.includes("f_auto") && url.includes("q_auto");

  // Already has both → nothing to do
  if (hasSize && hasAutoFormat) return url;

  // Has f_auto,q_auto but no size → inject w_x,h_y before the auto segment
  if (hasAutoFormat && !hasSize) {
    return url.replace(
      /(\/upload\/(?:[^/]+\/)*)([^/]*(?:f_auto|q_auto)[^/]*)(\/)/, 
      `$1w_${x},h_${y},$2$3`
    );
  }

  // Has size but no auto format → append f_auto,q_auto into the size segment
  if (hasSize && !hasAutoFormat) {
    const sizeSegmentRegex = new RegExp(
      `(\\/upload\\/(?:[^/]+\\/)*)([^/]*(?:w_${x}|h_${y})[^/]*)(\\/)`
    );
    return url.replace(sizeSegmentRegex, `$1$2,f_auto,q_auto$3`);
  }

  // Has neither → add both from scratch
  return url.replace("/upload/", `/upload/w_${x},h_${y},f_auto,q_auto/`);
};

const REFERRAL_TEMPLATE =
  'https://res.cloudinary.com/deavhufn6/image/upload';

const REFERRAL_CARDS = [
  {
    // "Earn Real Cash Daily" — SQUARE (4:4) card, white box across the bottom. (NEW, d8)
    id: 'v1782454843/tasks/k2iosrhpritpbuluvhtk.jpg',
    y: 125,
    fonts: [85, 72, 60, 48],
  },
  {
    // "Refer Friends. Earn Together!" — white box in the lower-middle. (original)
    id: 'v1782295363/tasks/nrwblnkyq8kudcfbexed.jpg',
    y: 200,
    fonts: [120, 95, 75, 60],
  },
];

export const REFERRAL_CARD_COUNT = REFERRAL_CARDS.length;

const fontForLength = (fonts, len) =>
  len <= 8 ? fonts[0] : len <= 11 ? fonts[1] : len <= 14 ? fonts[2] : fonts[3];

export const buildReferralImageUrl = (code, index = 0) => {
  const card = REFERRAL_CARDS[index % REFERRAL_CARDS.length] || REFERRAL_CARDS[0];
  const text = String(code || '').toUpperCase();
  if (!text) {
    return `${REFERRAL_TEMPLATE}/f_auto,q_auto,c_limit,w_500/${card.id}`;
  }
  const fontSize = fontForLength(card.fonts, text.length);
  const encoded = encodeURIComponent(text);
  return `${REFERRAL_TEMPLATE}/l_text:Arial_${fontSize}_bold:${encoded},co_rgb:1a2b6b/fl_layer_apply,g_south,x_0,y_${card.y}/f_auto,q_auto,c_limit,w_500/${card.id}`;
};
// limitCloudinaryWidth
export const limitCloudinaryWidth = (url, w) => {
  if (!url || typeof url !== "string") return url;

  const isCloudinary =
    url.includes("res.cloudinary.com") && url.includes("/upload/");

  if (!isCloudinary) return url;

  // Already has c_limit,w_X → nothing to do
  if (new RegExp(`[,/]c_limit[,/]`).test(url) && new RegExp(`[,/]w_${w}[,/]`).test(url)) {
    return url;
  }

  // Strip any existing transformation segment and inject fresh
  return url.replace("/upload/", `/upload/c_limit,w_${w},f_auto,q_auto/`);
};